export default __webpack_public_path__ + "static/media/Head_6_Ear_3_C1.f52358b2.svg";